// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Get all embedded video references
      ui.videos = doms(".embed-video-file video");

      // Set the initial scroll flag
      block.scrolling = false;

      // If no videos on the page, skip
      if (!ui.videos.length) {
        return;
      }

      // Check if scrolling at an interval instead of on scroll
      window.setInterval(block.watchScroll, 10);

      // Set the scrolling flag on scroll, to avoid binding directly to this
      window.addEventListener("scroll", block.handleScroll);

      // Watch for videos end and set an attribute for the controls to use
      block.watchVideos();

      // Handle the pause/replay controls for the video
      block.handleControls();

    },

    /**
     * Method to handle controls.
     *
     * @method block.handleControls
     */
    handleControls: function() {

      var buttons = doms(".embed-control");

      for (var index = 0; index < buttons.length; index++) {
        buttons[index].onclick = function(event) {

          event.preventDefault();

          var target = event.target;
          var data = target.dataset;

          if (data.action === "none") {
            return;
          }

          var video = target.parentNode.querySelector("video");

          if (data.action === "replay") {
            video.play();
          } else {
            if (video.paused) {
              video.play();
              data.action = "pause";
              target.innerHTML = data.pause;
            } else {
              video.pause();
              data.action = "play";
              target.innerHTML = data.play;
            }
          }

        };
      }

    },

    /**
     * Method to handle videos.
     *
     * @method block.watchVideos
     */
    watchVideos: function() {

      for (var index = 0; index < ui.videos.length; index++) {

        // TODO: Improve the below by reducing the redundancy
        ui.videos[index].addEventListener("play", function(event) {
          // TOOD: Remove chaining here and use IDs or something else to reference
          var parent = event.target.parentNode.parentNode;
          var button = dom(".embed-control", parent);
          button.dataset.action = "pause";
        });

        ui.videos[index].addEventListener("ended", function(event) {
          // TOOD: Remove chaining here and use IDs or something else to reference
          var parent = event.target.parentNode.parentNode;
          var button = dom(".embed-control", parent);
          button.dataset.action = "replay";
          button.innerHTML = button.dataset.replay;
        });

      }

    },

    /**
     * Method to handle on scoll logic.
     *
     * @method block.handleScroll
     */
    handleScroll: function() {

      block.scrolling = true;

    },

    /**
     * Method to handle wathcing block scoll.
     *
     * @method block.watchScroll
     */
    watchScroll: function() {

      if (!block.scrolling) {
        return;
      }

      var viewport = window.innerHeight;

      for (var index = 0; index < ui.videos.length; index++) {
        var video = ui.videos[index];
        var height = video.offsetHeight / 2;
        var position = video.getBoundingClientRect();
        if (position.top > height && position.top < viewport - height) {
          if (!video.dataset.played) {
            video.play();
            video.dataset.played = true;
          }
        }
      }

      block.scrolling = false;

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
